import configHelper from '@/config/ConfigHelper'
import { i18n } from '@/i18n'

function GenerateConfig () {
  return [
    {
      id: '01',
      name: i18n.t('tipos.rol_administrativecenter.fiscal'),
    },
    {
      id: '02',
      name: i18n.t('tipos.rol_administrativecenter.receiver'),
    },
    {
      id: '03',
      name: i18n.t('tipos.rol_administrativecenter.payer'),
    },
    {
      id: '04',
      name: i18n.t('tipos.rol_administrativecenter.buyer'),
    },
    {
      id: '05',
      name: i18n.t('tipos.rol_administrativecenter.collector'),
    },
    {
      id: '06',
      name: i18n.t('tipos.rol_administrativecenter.seller'),
    },
    {
      id: '07',
      name: i18n.t('tipos.rol_administrativecenter.payment_receiver'),
    },
    {
      id: '08',
      name: i18n.t('tipos.rol_administrativecenter.collection_receiver'),
    },
    {
      id: '09',
      name: i18n.t('tipos.rol_administrativecenter.issuer'),
    },
  ]
}

export function TIPOS_ROL_ADMINISTRATIVE_CENTER (state) {
  return configHelper.getConfig(state, 'TIPOS_ROL_ADMINISTRATIVE_CENTER', GenerateConfig)
}
